import { Action, createReducer, on } from "@ngrx/store";
import { CheckoutActions } from "../actions";
import { CheckoutAccordion, CheckoutAddressState, CheckoutCartsState, CheckoutModesState } from "../checkout.state";
import { AccordionType, CheckoutConstants } from "../../models/checkout.model";

const initialState: CheckoutCartsState = {
    loading: null,
    success: null,
    error: null,
    warehouseCart: null,
    quotationCart: null,
};

const checkoutCartsReducer = createReducer(
    initialState,
    on(
        CheckoutActions.loadCheckoutCartsList,
        (state: CheckoutCartsState) => ({
            ...state,
            loading: true,
            success: null,
            error: null,
        })
    ),
    on(
        CheckoutActions.loadCheckoutCartsListSuccess,
        (state: CheckoutCartsState, { payload }) => ({
            ...state,
            ...payload,
            loading: null,
            success: true,
            error: null,
        })
    ),
    on(
        CheckoutActions.loadCheckoutCartsListFail,
        (state: CheckoutCartsState, { payload }) => ({
            ...state,
            ...payload,
            loading: null,
            success: null,
        })
    ),
    on(
        CheckoutActions.loadCheckoutCartSuccess,
        (state: CheckoutCartsState, { payload, accordionType }) => {
            const cartType: string = (accordionType === AccordionType.WAREHOUSE) ? CheckoutConstants.WAREHOUSE_CART : CheckoutConstants.QUOTATION_CART;
            let prevStateAccordion: CheckoutAccordion = { ...state[cartType] };
            let currentStateAccordion: CheckoutAccordion = { ...payload[cartType] };
            let updatedAccordion = {
                [cartType]: {
                    ...currentStateAccordion,
                    formData: {
                        ...currentStateAccordion.formData,
                        deliveryAddressOptions: prevStateAccordion?.formData?.deliveryAddressOptions ?? null,
                        deliverModeOptions: prevStateAccordion?.formData?.deliverModeOptions ?? null
                    }
                }
            };
            return {
                ...state,
                loading: false,
                [cartType]: updatedAccordion[cartType]
            }
        }
    ),
    on(
        CheckoutActions.loadCheckoutCartFail,
        (state: CheckoutCartsState, { payload, accordionType }) => {
            const cartType: string = (accordionType === AccordionType.WAREHOUSE) ? CheckoutConstants.WAREHOUSE_CART : CheckoutConstants.QUOTATION_CART;
            let prevStateAccordion: CheckoutAccordion = { ...state[cartType] };
            let currentStateAccordion: CheckoutAccordion = { ...payload[cartType] };
            let updatedAccordion = {
                [cartType]: {
                    ...currentStateAccordion,
                    formData: {
                        ...currentStateAccordion.formData,
                        deliveryAddressOptions: prevStateAccordion?.formData?.deliveryAddressOptions ?? null,
                        deliverModeOptions: prevStateAccordion?.formData?.deliverModeOptions ?? null
                    }
                }
            };
            return {
                ...state,
                loading: false,
                [cartType]: updatedAccordion[cartType]
            }
        }
    ),
    on(
        CheckoutActions.loadShippingAddressSuccess,
        (state: CheckoutCartsState, { payload, accordionType }) => {
            let deliveryAddressState: CheckoutAddressState = {
                loading: null,
                success: true,
                error: null,
                addressData: payload
            }
            let updatedAccordion: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE)
                ? { ...state.warehouseCart }
                : { ...state.quotationCart };
            updatedAccordion = {
                ...updatedAccordion,
                formData: {
                    ...updatedAccordion.formData,
                    deliveryAddressOptions: { ...deliveryAddressState }
                }
            }
            return {
                ...state,
                [accordionType === AccordionType.WAREHOUSE ? 'warehouseCart' : 'quotationCart']: updatedAccordion
            }
        }
    ),
    on(
        CheckoutActions.loadShippingAddressFail,
        (state: CheckoutCartsState, { payload, accordionType }) => {
            let deliveryAddressState: CheckoutAddressState = {
                loading: null,
                success: null,
                error: payload,
                addressData: null
            }
            let updatedAccordion: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE)
                ? { ...state.warehouseCart }
                : { ...state.quotationCart };
            updatedAccordion = {
                ...updatedAccordion,
                formData: {
                    ...updatedAccordion.formData,
                    deliveryAddressOptions: { ...deliveryAddressState }
                }
            }
            return {
                ...state,
                [accordionType === AccordionType.WAREHOUSE ? 'warehouseCart' : 'quotationCart']: updatedAccordion
            }
        }
    ),
    on(
        CheckoutActions.updateShippingAddressSuccess,
        (state: CheckoutCartsState, { deliveryModesData, checkoutCartsData, accordionType }) => {
            let deliveryModesState: CheckoutModesState = {
                loading: null,
                success: true,
                error: null,
                modesData: deliveryModesData
            };
            let cartType: string = (accordionType === AccordionType.WAREHOUSE) ? CheckoutConstants.WAREHOUSE_CART : CheckoutConstants.QUOTATION_CART;
            let prevStateAccordion: CheckoutAccordion = { ...state[cartType] };
            let currentStateAccordion: CheckoutAccordion = { ...checkoutCartsData[cartType] };
            let updatedAccordion = {
                [cartType]: {
                    ...currentStateAccordion,
                    formData: {
                        ...currentStateAccordion.formData,
                        deliverModeOptions: { ...deliveryModesState },
                        deliveryAddressOptions: prevStateAccordion?.formData?.deliveryAddressOptions ?? null
                    }
                }
            };
            return {
                ...state,
                loading: false,
                [cartType]: updatedAccordion[cartType]
            };
        }
    ),
    on(
        CheckoutActions.updateShippingAddressFail,
        (state: CheckoutCartsState, { payload, accordionType }) => {
            let updatedAccordion: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE)
                ? { ...state.warehouseCart }
                : { ...state.quotationCart };
            let deliveryAddressState: CheckoutAddressState = {
                ...updatedAccordion.formData.deliveryAddressOptions,
                loading: null,
                success: null,
                error: payload,
            }
            updatedAccordion = {
                ...updatedAccordion,
                formData: {
                    ...updatedAccordion.formData,
                    deliveryAddressOptions: { ...deliveryAddressState }
                }
            }
            return {
                ...state,
                loading: false,
                [accordionType === AccordionType.WAREHOUSE ? 'warehouseCart' : 'quotationCart']: updatedAccordion
            }
        }
    ),
    on(
        CheckoutActions.updateOtherShippingAddressSuccess,
        (state: CheckoutCartsState, { payload, accordionType }) => {
            let updatedWarehouseCart: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE) ? null : { ...state.warehouseCart };
            payload = {
                ...payload,
                warehouseCart: updatedWarehouseCart,
                quotationCart: {
                    ...payload.quotationCart,
                    formData: {
                        ...payload.quotationCart.formData,
                        deliveryAddressOptions: state.quotationCart?.formData?.deliveryAddressOptions ?? null,
                        deliverModeOptions: state.quotationCart?.formData?.deliverModeOptions ?? null
                    }
                }
            };

            return {
                ...payload,
                loading: false,
                success: true,
                error: null,
            }
        }
    ),
    on(
        CheckoutActions.loadShippingMethodSuccess,
        (state: CheckoutCartsState, { payload, accordionType }) => {
            let deliveryModesState: CheckoutModesState = {
                loading: null,
                success: true,
                error: null,
                modesData: payload
            }
            let updatedAccordion: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE)
                ? { ...state.warehouseCart }
                : { ...state.quotationCart };
            updatedAccordion = {
                ...updatedAccordion,
                formData: {
                    ...updatedAccordion.formData,
                    deliverModeOptions: { ...deliveryModesState }
                }
            }
            return {
                ...state,
                [accordionType === AccordionType.WAREHOUSE ? 'warehouseCart' : 'quotationCart']: updatedAccordion
            }
        }
    ),
    on(
        CheckoutActions.loadShippingMethodFail,
        (state: CheckoutCartsState, { payload, accordionType }) => {
            let deliveryModesState: CheckoutModesState = {
                loading: null,
                success: null,
                error: payload,
                modesData: null
            }
            let updatedAccordion: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE)
                ? { ...state.warehouseCart }
                : { ...state.quotationCart };
            updatedAccordion = {
                ...updatedAccordion,
                formData: {
                    ...updatedAccordion.formData,
                    deliverModeOptions: deliveryModesState
                }
            }
            return {
                ...state,
                [accordionType === AccordionType.WAREHOUSE ? 'warehouseCart' : 'quotationCart']: updatedAccordion
            }
        }
    ),
    on(
        CheckoutActions.updateShippingMethodSuccess,
        (state: CheckoutCartsState, { checkoutCartsData, accordionType }) => {
            const cartType: string = (accordionType === AccordionType.WAREHOUSE) ? CheckoutConstants.WAREHOUSE_CART : CheckoutConstants.QUOTATION_CART;
            let prevStateAccordion: CheckoutAccordion = { ...state[cartType] };
            let currentStateAccordion: CheckoutAccordion = { ...checkoutCartsData[cartType] };
            let updatedAccordion = {
                [cartType]: {
                    ...currentStateAccordion,
                    formData: {
                        ...currentStateAccordion.formData,
                        deliveryAddressOptions: prevStateAccordion?.formData?.deliveryAddressOptions ?? null,
                        deliverModeOptions: prevStateAccordion?.formData?.deliverModeOptions ?? null
                    },
                }
            };
            return {
                ...state,
                loading: false,
                [cartType]: updatedAccordion[cartType]
            }
        }
    ),
    on(
        CheckoutActions.updateShippingMethodFail,
        (state: CheckoutCartsState, { payload, accordionType }) => {
            let updatedAccordion: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE)
                ? { ...state.warehouseCart }
                : { ...state.quotationCart };
            let deliveryModesState: CheckoutModesState = {
                ...updatedAccordion.formData.deliverModeOptions,
                loading: null,
                success: null,
                error: payload,
            }
            updatedAccordion = {
                ...updatedAccordion,
                formData: {
                    ...updatedAccordion.formData,
                    deliverModeOptions: deliveryModesState
                }
            }
            return {
                ...state,
                loading: false,
                [accordionType === AccordionType.WAREHOUSE ? 'warehouseCart' : 'quotationCart']: updatedAccordion
            }
        }
    ),
    on(
        CheckoutActions.updateMinOrderAmntPopup,
        (state: CheckoutCartsState, { accordionType }) => {
            let updatedAccordion: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE)
                ? { ...state.warehouseCart }
                : { ...state.quotationCart };
            updatedAccordion = {
                ...updatedAccordion,
                minOrderAmount: {
                    ...updatedAccordion.minOrderAmount,
                    displayModal: false
                }
            }
            return {
                ...state,
                [accordionType === AccordionType.WAREHOUSE ? 'warehouseCart' : 'quotationCart']: updatedAccordion
            }
        }
    ),
    on(
        CheckoutActions.clearMinOrderAmntPopup,
        (state: CheckoutCartsState, { accordionType }) => {
            let updatedAccordion: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE)
                ? { ...state.warehouseCart }
                : { ...state.quotationCart };
            updatedAccordion = {
                ...updatedAccordion,
                minOrderAmount: null
            }
            return {
                ...state,
                [accordionType === AccordionType.WAREHOUSE ? 'warehouseCart' : 'quotationCart']: updatedAccordion
            }
        }
    ),
    on(
        CheckoutActions.removeAllPartsSuccess,
        (state: CheckoutCartsState, { accordionType }) => {
            let updatedWarehouseCart: CheckoutAccordion = (accordionType === AccordionType.WAREHOUSE) ? null : { ...state.warehouseCart };
            let updatedQuotationCart: CheckoutAccordion = (accordionType === AccordionType.QUOTATION) ? null : { ...state.quotationCart };

            return {
                ...state,
                loading: false,
                success: true,
                error: null,
                warehouseCart: updatedWarehouseCart,
                quotationCart: updatedQuotationCart
            }
        }
    ),
    on(
        CheckoutActions.clearCheckoutState,
        () => ({ ...initialState })
    )
);

export function reducer(state: CheckoutCartsState | undefined, action: Action) {
    return checkoutCartsReducer(state, action);
}